/**
 * 项目整体开关配置
 */

export default {
  /**
   * 是否开启禁止浏览网站功能
   * 首页有个遮罩 弹框
   * 页面所有功能不可操作
   * 1, 所有功能都不可以访问 noAction: true,  其他为false
   * 2, 只放开客商注册共功能 noActor: true, onlayReg: true, 其他为false
   * 3, 展商可以登录（不可注册），只能访问部分功能（工作台）
   *    客商可以登录注册，只能访问部分功能（工作台） noActor2: true, onlayReg: true, onlayReg2: true, 其他为false
   */
  noAction: false,
  // 禁止展商操作
  noActor: false,
  // 禁止展商操作2 (第二次限制)
  noActor2: false,
  // 只开启注册功能
  onlayReg: false,
  // 禁止客商操作2 (第二次限制)
  onlayReg2: false,
  // 是否开启使用第三方登录
  thirdPartyLogin: false,

}